// extracted by mini-css-extract-plugin
export var col = "WaterCooler-module--col--KbTrz";
export var container = "WaterCooler-module--container--6ZSiK";
export var header = "WaterCooler-module--header--nao3l";
export var row = "WaterCooler-module--row--Q2kb9";
export var section = "WaterCooler-module--section--RQ2tw";
export var sectionBg = "WaterCooler-module--section-bg--Bpcdv";
export var subheadline = "WaterCooler-module--subheadline--++W-S";